var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSmile = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.5C6.75329 2.5 2.5 6.75329 2.5 12C2.5 17.2467 6.75329 21.5 12 21.5C17.2467 21.5 21.5 17.2467 21.5 12C21.5 6.75329 17.2467 2.5 12 2.5ZM1.5 12C1.5 6.20101 6.20101 1.5 12 1.5C17.799 1.5 22.5 6.20101 22.5 12C22.5 17.799 17.799 22.5 12 22.5C6.20101 22.5 1.5 17.799 1.5 12Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.7 13.6C7.92058 13.4346 8.23336 13.479 8.39924 13.699C8.39949 13.6994 8.39975 13.6997 8.4 13.7L8 14C8.4 13.7 8.39989 13.6999 8.39978 13.6997L8.3996 13.6995L8.39933 13.6991L8.40051 13.7007L8.40948 13.7121C8.41825 13.7232 8.43258 13.741 8.45232 13.7645C8.49185 13.8116 8.55289 13.8815 8.63443 13.9666C8.79792 14.1372 9.04141 14.3664 9.35658 14.5957C9.98887 15.0555 10.8878 15.5 12 15.5C13.1122 15.5 14.0111 15.0555 14.6434 14.5957C14.9586 14.3664 15.2021 14.1372 15.3656 13.9666C15.4471 13.8815 15.5082 13.8116 15.5477 13.7645C15.5674 13.741 15.5817 13.7232 15.5905 13.7121L15.5995 13.7007L15.6 13.7C15.6001 13.6999 15.6001 13.6998 15.6002 13.6997M15.6002 13.6997C15.766 13.4791 16.0792 13.4344 16.3 13.6C16.5209 13.7657 16.5657 14.0791 16.4 14.3L16.0177 14.0133C16.4 14.3 16.3999 14.3002 16.3997 14.3004L16.3995 14.3007L16.3988 14.3016L16.397 14.304L16.3918 14.3109L16.3746 14.3328C16.3601 14.3511 16.3398 14.3762 16.3137 14.4074C16.2614 14.4697 16.1857 14.5561 16.0876 14.6585C15.8917 14.8629 15.6039 15.1336 15.2316 15.4044C14.4889 15.9446 13.3878 16.5 12 16.5C10.6122 16.5 9.51113 15.9446 8.76841 15.4044C8.39609 15.1336 8.10832 14.8629 7.91244 14.6585C7.8143 14.5561 7.73862 14.4697 7.68635 14.4074C7.6602 14.3762 7.63985 14.3511 7.62543 14.3328L7.60824 14.3109L7.603 14.304L7.60122 14.3016L7.60054 14.3007L7.60025 14.3004C7.60012 14.3002 7.6 14.3 8 14L7.6 14.3C7.43431 14.0791 7.47909 13.7657 7.7 13.6",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 9C8.5 8.72386 8.72386 8.5 9 8.5H9.01C9.28614 8.5 9.51 8.72386 9.51 9C9.51 9.27614 9.28614 9.5 9.01 9.5H9C8.72386 9.5 8.5 9.27614 8.5 9Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 9C14.5 8.72386 14.7239 8.5 15 8.5H15.01C15.2861 8.5 15.51 8.72386 15.51 9C15.51 9.27614 15.2861 9.5 15.01 9.5H15C14.7239 9.5 14.5 9.27614 14.5 9Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSmile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/smile.ff02d73dcb29b3a19d076192ac2d4494.svg";